import React, { useEffect, useState, useRef } from 'react';
import Player from './../player/Player';
import Performances from './../player/Performances';
import Grid from '@mui/material/Grid';
import navigationStore from './../../stores/navigation';
import playerStore from './../../stores/player';


function ContainerRightBottom() {

  const isSmallVideo = playerStore((state) => state.isSmallVideo);
  const safeArea = navigationStore((state) => state.safeArea);

  useEffect(() => {
    window.dispatchEvent(new Event('refitbuttons'));
  }, [isSmallVideo]);

  return (
    <Performances className="muvika-container-right-bottom " style={{
     paddingRight: safeArea ? (safeArea.right + 18) + "px" : "1.125rem", paddingBottom:"1.3rem", width:"100%"
    }} />
  );
}

export default ContainerRightBottom;